import React, {
    useEffect,
    useState,
} from 'react';

import { Redirect, useLocation } from 'react-router-dom';
const AuthGuard = ({ children, getUser }) => {
    const [previousRoute, setPreviousRoute] = useState(null);
    const { pathname } = useLocation();
    let authenticated = true;

    useEffect(() => {
        if (previousRoute !== null) setPreviousRoute(pathname)
    }, [pathname, previousRoute])

    if (authenticated) return <>{children}</>
    else {
        return (
            <Redirect
                to={{
                    pathname: '/session/login',
                    state: { redirectUrl: previousRoute },
                }}
            />
        )
    }
}
export default AuthGuard
